export default __webpack_public_path__ + "static/media/homepage_20.36fc6c82.png";